import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import Card from "../Component/FixedCosts/Card";
import Headings from "../Component/FixedCosts/Headings";
import FixedCostsHints from "../Component/FixedCosts/FixedCostsHints";
import { useAuth } from "../Context/AuthContext";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentPage } from "../Redux/Actions/activePage";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ImportFromYear from "../Component/FixedCosts/ImportFromYear";
//test windowsize
import useWindowSize from "../Component/use-window-size";
import CardMobile from "../Component/FixedCosts/CardMobile";
const FixedCosts = () => {
  const { fixedCostData, setFixedCostData, postLocalData } = useAuth();

  const [headingFocused, setHeadingFocused] = useState("");
  const [draggableOrder, setDraggableOrder] = useState(fixedCostData);
  const [input] = useState({
    category: "",
    amount: "0",
  });

  //get current windowsize
  const size = useWindowSize();
  //redux
  const dispatch = useDispatch();
  const activeYear = useSelector((state) => state.year.year);
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);

  function submitHandler() {
    postLocalData(input);
  }

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      const setRowsIfMissing =
        fixedCostData &&
        fixedCostData.fixedCostData.filter((item) => item.year === activeYear)
          .length;
      if (setRowsIfMissing < 1) {
        const delayEditData = setTimeout(() => {
          postLocalData(input);
        }, 500);
        return () => clearTimeout(delayEditData);
      }
    }
    return () => {
      isMounted = false;
    };
  }, [activeYear, fixedCostData, input, postLocalData]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      dispatch(setCurrentPage("Fastakostnader"));
    }
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  function handleOnDragEnd(result) {
    if (!result.destination) return;
    const items = Array.from(draggableOrder.fixedCostData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setDraggableOrder({ fixedCostData: items });
    setFixedCostData({ fixedCostData: items });
  }

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setDraggableOrder(fixedCostData);
    }
    return () => {
      isMounted = false;
    };
  }, [fixedCostData]);

  return (
    <Row className="mt-5">

      <FixedCostsHints />  
      
      <Col xs={size.width < sizeForMobile ? 0 : 16} className="g-0">
        {size.width < sizeForMobile ? "" : <Headings headingFocused={headingFocused} />}
        <div className={size.width < sizeForMobile ? "scrollbox-mobile" : "scrollbox"}>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="cardOrder">
              {(provided) => (
                <div
                  className="content-wrapper"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {draggableOrder &&
                    draggableOrder.fixedCostData
                      .filter((item) => item.year === activeYear)
                      .map((card, index) => (
                        <Draggable
                          key={card.id}
                          draggableId={card.id}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              ref={provided.innerRef}
                            >
                              {size.width < sizeForMobile ? (
                                <CardMobile data={card} />
                              ) : (
                                <Card
                                  data={card}
                                  setHeadingFocused={setHeadingFocused}
                                />
                              )}
                            </div>
                          )}
                        </Draggable>
                      ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div
          className="container-buttons-below-scrollbox"
          style={{ marginTop:"2%", marginRight: "5%" }}
        >
          <div className="button-add-row" onClick={submitHandler}>
            <p className="plus">+</p>
          </div>
          {size.width < sizeForMobile ? "" : <ImportFromYear />}
        </div>
      </Col>
    </Row>
  );
};

export default FixedCosts;
